import { Box, Flex, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { SanityImage } from '~/components/sanity-image';

import { AboutUsTemplate } from '../model';

export function AwardsSection({ title, awards }: { title?: string; awards: AboutUsTemplate['awards'] }) {
  if (!awards?.length) return null;

  return (
    <Box as='section' bg='gray.100' py='48px'>
      <ContentContainer>
        <Flex
          alignItems='center'
          flex={1}
          flexWrap='wrap'
          gap='32px'
          justifyContent={{ base: 'center', lg: 'space-between' }}
        >
          {title && (
            <Heading
              marginBottom={{ base: '32px', lg: 0 }}
              maxWidth={{ base: '100%', lg: '244px' }}
              size='marketing-3xl'
              textAlign={{ base: 'center', lg: 'left' }}
              width={{ base: '100%', lg: 'calc(100% - 244px)' }}
            >
              {title}
            </Heading>
          )}
          {awards.map((award) => (
            <SanityImage key={award._id} image={award.logo} />
          ))}
        </Flex>
      </ContentContainer>
    </Box>
  );
}
